import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Waterfall2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.WATERFALL2;
}

export default Waterfall2PoiTileEntity;
